import $ from "jquery";
import Cookie from "js-cookie";
import Tinysort from "tinysort";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let loadingTeasers     = false;
		const $section         = $( 'section.archive' );
		const $filter          = $( '.archive__filter' );
		const $teaserContainer = $( '.archive__posts' );
		const $loadMoreButton  = $( '.archive__load-more' );
		const cookieName       = $filter.data( 'cookie' ) ? $filter.data( 'cookie' ) : new Date().getFullYear();
		const action           = $teaserContainer.data( 'action' );
		const postsPerPage     = $teaserContainer.data( 'post-count' );
		const postsTotal       = $teaserContainer.data( 'post-total' );
		const loadedYear       = $filter.data( 'loaded-year' );
		let year               = Cookie.get( cookieName ) ? parseInt( Cookie.get( cookieName ) ) : loadedYear;
		let page               = $teaserContainer.data( 'page' );
		let noMoreTeasers      = false;

		/**
		 * Insert the post teasers.
		 *
		 * @param response
		 */
		function addTeasers( response ) {
			$teaserContainer.append( response.data.markup );
		}

		/**
		 * Insert the post teasers.
		 *
		 * @param response
		 */
		function replaceTeasers( response ) {
			if ( typeof response.data.markup !== 'undefined' ) {
				$teaserContainer.html( '' ).append( response.data.markup );
			}
			if ( response.data.posts === 0 ) {
				setNoResults();
			} else {
				unsetNoResults();
			}
		}

		/**
		 * Set class to indicate posts are loading.
		 */
		function setLoading() {
			$teaserContainer.addClass( 'loading' );
			unsetNoResults();
		}

		/**
		 * Remove class that indicate posts are loading.
		 */
		function unsetLoading() {
			$teaserContainer.removeClass( 'loading' );
		}


		/**
		 * Set class to indicate posts are loading.
		 */
		function setNoResults() {
			$section.addClass( 'no-results' );
		}

		/**
		 * Remove class that indicate posts are loading.
		 */
		function unsetNoResults() {
			$section.removeClass( 'no-results' );
		}

		/**
		 * If the archive has a filter, get the values.
		 *
		 * @returns {*[]}
		 */
		function getFilterValue( element ) {
			let value = undefined;

			if ( $filter.length ) {
				if ( $( '#' + element, $filter ).length ) {
					return $( '#' + element, $filter ).val();
				}
			}

			return value;
		}

		function getFilterButtonByYear( year ) {
			return $( 'button[data-year=' + year + ']' );
		}

		/**
		 * Load more posts
		 */
		function loadMorePosts() {
			let data = {
				'action': action,
				'postsPerPage': postsPerPage,
				'postsTotal': postsTotal,
				'page': page,
			};

			let moreTeasers = $.ajax(
				{
					type: "GET",
					data: data,
					url: sedermera.ajax_url,
					success: function ( response ) {
						if ( response.data.posts === postsPerPage ) {
							page++;
						} else {
							$loadMoreButton.attr( "disabled", "disabled" );
							noMoreTeasers = true;
						}
						addTeasers( response );
						loadingTeasers = false;
					},
					failure: function ( response ) {
						console.log( response );
						loadingTeasers = false;
					}
				}
			);
		}

		function changeArchivePage( e ) {
			e.preventDefault();

			switch ( e.type ) {
				case 'click' :
					year = e.target.dataset.year;
					$( 'button', $filter ).removeClass( 'active' );
					$( e.target ).addClass( 'active' );
					break;

				case 'change' :
					year = getFilterValue( 'year' );
					break;
			}

			Cookie.set( cookieName, year );
			setLoading();

			let data = {
				'action': action,
				'year': year,
			};

			$.ajax(
				{
					type: "GET",
					data: data,
					url: sedermera.ajax_url,
					success: function ( response ) {
						replaceTeasers( response );
						unsetLoading();
					},
					failure: function ( response ) {
						console.log( response );
					}
				}
			);
		}

		// On year change fetch new year data
		if ( $filter.length ) {
			if ( $( '#year', $filter ).length ) {
				$( '#year', $filter ).on( 'change', changeArchivePage );
			}

			if ( $( '.filter-trigger', $filter ).length ) {
				$( '.filter-trigger', $filter ).on( 'click', changeArchivePage );
			}

			$( document ).ready(
				function () {
					let table = document.getElementById( 'table-sortable' );

					if ( loadedYear !== year ) {
						const $yearButton = getFilterButtonByYear( year );
						$yearButton.click();
					}

					if ( table ) {
						let tableHead    = table.querySelector( 'thead' );
						let tableHeaders = tableHead.querySelectorAll( 'th' );
						let tableBody    = table.querySelector( 'tbody' );

						tableHead.addEventListener(
							'click',
							function ( e ) {
								let tableHeader   = e.target
									, textContent = tableHeader.textContent
									, tableHeaderIndex, isAscending, order;
								if ( textContent !== 'add row' ) {
									while ( tableHeader.nodeName !== 'TH' ) {
										tableHeader = tableHeader.parentNode;
									}
									tableHeaderIndex = Array.prototype.indexOf.call( tableHeaders, tableHeader );
									isAscending      = tableHeader.getAttribute( 'data-order' ) === 'asc';
									order            = isAscending ? 'desc' : 'asc';
									tableHeader.setAttribute( 'data-order', order );
									Tinysort(
										tableBody.querySelectorAll( 'tr' ),
										{
											selector: 'td:nth-child(' + ( tableHeaderIndex + 1 ) + ')',
											order: order
										}
									);
								}
							}
						);
					}
				}
			);
		}

		if ( $loadMoreButton.length ) {
			$loadMoreButton.on(
				'click',
				loadMorePosts
			);
		}
	}
);
